import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdbreact";
import BasicButton from "../../../SharedComponents/BasicButton/BasicButton";
import BasicTextField from "../../../SharedComponents/BasicTextField/BasicTextField";
import BasicCheckbox from "../../../SharedComponents/BasicCheckbox/BasicCheckbox";
import BasicLabel from "../../../SharedComponents/BasicLabel/BasicLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicTextArea from "../../../SharedComponents/BasicTextArea/BasicTextArea";
import SelectField from "../../../SharedComponents/SelectField/SelectField";
import SearchSelectField from "../../../SharedComponents/SearchSelectField"
import "./NewMaintitleClearenceRecord.scss";
import { withUserContext } from '../../../../contexts/UserContext';
import * as Constants from '../../../../constants/constants';
import ClearTrackService from '../../../../services/service';
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { initialMaintitleClearanceRecord, mockSong2, mainTitleWritersList } from "./config";
import messages from '../../../../Common/Messages.json';
import Popover from '@material-ui/core/Popover';
import axios from 'axios';
import {validateNumbersOnly} from "../../../../Common/Helper"
import { clearanceRecordPermissionsConfig } from '../../../EpisodeAndClearence/EpisodeAndClearenceDetails/Config';
import EditSongDetails from '../../../EpisodeAndClearence/EditSong/EditSongDetails';
import SearchFieldWithAddValue from '../../../SharedComponents/SearchFieldWithAddValue';
import MessageModal from "../../../SharedComponents/MessageModal";
import MainViewModalComponent from "../../../../Common/MainViewModalLayout/Modal/Modal";
class NewMainTitleClearanceRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postInitiated: false,
            songOptions: [],
            inActiveSongOptions:[],
            mainTitleClearanceData: this.formatMainTitleClearanceDetails(JSON.parse(JSON.stringify({ ...initialMaintitleClearanceRecord }))),
            useOptions: [],
            isLoading: false,
            fieldChanged: false,
            isPosting: false,
            performerOptions: [],
            performerList: [],
            songUse: [],
            division_id: null,
            isFetchingMainTitleDetails: false,
            isPerformerFetching: [],
            isSongFetching: [],
            searchCancelToken: null,
            deletedSongs: [],
            existingSongList: [],
            customNotes: null,
            newSongRowIndex: null,
            loadingSongs:false,
            searchSelect: true,
            openInActiveSongModal:false,
            displayAddNewSongOption: false,
            searchedSongString: null,
            searchedSongIndex: null,
            isEditingPerformer:false,
            editingPerformerSongIndex:null,
            writerOptions:[],
            deletedWriters: [],
            writerMode: null,
            selectedWriterIndex: null,
            selectedSongIndex: null,
            isSendEmail: false,
            isMusicSupervisorEmail: false,
        };
    };

    formatMainTitleClearanceDetails = (response) => {
        if (response.songs_list.length === 0) {
            response.songs_list.push(JSON.parse(JSON.stringify({ ...mockSong2 })))
            return response;
        } else {
            let newSongList = response?.songs_list?.map(item => {
                let newItem = { ...item }
                newItem.selected_song = {
                    'value': item?.song_id,
                    'text': `${item?.song_title}${item?.writer?.length > 0 ? '('+item?.writer?.map(ele => ele?.writer_name ? ele?.writer_name : ''+ele?.affiliation_name ? '-'+ele?.affiliation_name : '')+')' : ''}` 
                }
                newItem.selected_performer = {
                    'value': item?.performer_id,
                    'text': item?.performer_name
                }
                newItem.min = item?.duration ? item?.duration?.split(":")[0] : null
                newItem.sec= item?.duration ? item?.duration?.split(":")[1] : null
                delete newItem.duration
                return newItem
            })
            response.songs_list = newSongList
            return response
        }
    }

    componentDidMount() {
        this.getEntity("useOptions", "MUSIC_USES", "");
        if (this.props.mode === "New") {
            this.handleChange("guaranteed_eps", this.props?.showSeasonDetails?.proj_eps)
        }
        if (this.props.mode === "Edit") {
            this.getMainTitleRecord(this.props?.mainTitleId)
        } else  {
            this.getSongs(" ", 0, "fromDidMount")
        }
        const divisionRoles = this.props?.userContext?.active_tenant?.division_role || [];
        const validRoles = ['Music Supervisor', 'Music Editor/Supervisor'];
        const isMusicSupervisorEmail = divisionRoles.every(role => validRoles.includes(role?.role_name));
        this.setState({ isMusicSupervisorEmail });
    }

    getEntity = (entity, entitytype, searchString) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
            `/entitySearch?entity=${entitytype}&searchString=${searchString}`, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = [];
                if (entitytype === 'MUSIC_USES') {
                    formattedList = response?.data?.map(item => ({ value: item.music_uses_id, label: item.abbreviation ,is_active: item.is_active }));
                }
                this.setState({ [entity]: formattedList });
            },
                (err) => {
                    console.log("Error in fetching entities:", err)
                })
    }

    getPerformer = (song_id, index, selectedPerformerId = null) => {
      ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/songDetails?song_id=${song_id}`, this.props.userContext?.active_tenant?.tenant_id)
        .then(response => {
            let songDoNotUse = response?.data[0]?.song_is_do_not_use    
            let tempMainTitleClearanceData = this.state.mainTitleClearanceData;
            tempMainTitleClearanceData.songs_list[index]["is_PD"] = response?.data?.[0]?.is_PD;
            let formattedList = Array.isArray(response.data[0]?.performers_list)? response.data[0]?.performers_list.map(item => ({ value: item.performer_id, text: item.performer_name })) : [];                     
            if (formattedList.length > 0 && !selectedPerformerId) {     
                     this.handleShowChange("performer", formattedList[formattedList.length - 1], index)
            } else if (!selectedPerformerId){      
                       this.handleShowChange("performer", null, index)
            }                     
             let performerList = [...this.state.performerList]
             performerList[index] = formattedList    
             let songUseArr = [...this.state.songUse]
             songUseArr[index] = songDoNotUse            
             if (!selectedPerformerId) {
            this.setState({ performerList,songUse: songUseArr,isEditingPerformer: false,editingPerformerSongIndex: null});
            return;
          }            
          const isPerformerInList = formattedList.some(
            performer => performer.value === selectedPerformerId
          );   
          this.setState({performerList,songUse: songUseArr,
            isEditingPerformer: !isPerformerInList,
            editingPerformerSongIndex: !isPerformerInList ? index : null
          });             
        })
        .catch(err => {           
          console.error("Error fetching performer details:", err);
          this.setState({
            isEditingPerformer: false,
            editingPerformerSongIndex: null,
            mainTitleClearanceData: tempMainTitleClearanceData
          });
        });
    }

    getPerformerDetails = (searchString, index) => {
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel("Operation canceled due to new request");
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        let flags = [...this.state.isPerformerFetching]
        flags[index] = true
        this.setState({ isPerformerFetching: flags })
        ClearTrackService.getDataWithCancel(Constants.ClearTrackServiceBaseUrl +
            `/entitySearch?entity=PERFORMER&searchString=${searchString}`, cancelToken, this.props.userContext?.active_tenant?.tenant_id)
            .then((res) => {
                let formattedList = res?.data?.map(item => ({ value: item?.performer_id, text: item?.performer_name }));
                if (this.state.performerList[index]?.length > 0) {
                    this.state.performerList[index].map((item) => {
                        formattedList.unshift(item)
                    })
                }
                let performer = [...this.state.performerOptions]
                performer[index] = formattedList
                let flags = [...this.state.isPerformerFetching]
                flags[index] = false
                this.setState({ isPerformerFetching: flags, performerOptions: performer })
            })

            .catch((err) => {
                let flags = [...this.state.isPerformerFetching]
                flags[index] = false
                this.setState({ isPerformerFetching: flags })
                console.log("error")
            });
    };
    getInactiveSongs = async (value, index) => {
        let searchObj = {
            'data_type': 'SONGS',
            'search_string': value,
        };
        this.setState({inActiveSongFeatching : true});
    
        try {
            const response = await ClearTrackService.getDataParams(
                Constants.ClearTrackServiceBaseUrl + '/globalSearch',
                searchObj,
                this.props.userContext?.active_tenant?.tenant_id,
                null
            );
    
            let formattedListData = response?.data?.data?.map(item => ({
                value: item?.id?.split('_')[1],
                text: item?.songTitle.trim(),
                isSongActive: item?.is_active,
                songWithWriter : item?.name
            }));
    
            let inActiveSongFormatedList = formattedListData?.filter(item => item.isSongActive === 0 && item.text.toLowerCase() === value.toLowerCase());
            if (inActiveSongFormatedList.length > 0) {
                this.setState({
                    inActiveSongFeatching: false,
                    inActiveSongOptions: inActiveSongFormatedList,
                    openInActiveSongModal: true
                });
            }
            this.setState({ inActiveSongFeatching: false})
            return inActiveSongFormatedList;
        } catch (error) {
            console.error("Error:", error);
            this.setState({ inActiveSongFeatching: false})
        }
    };
    

    getSongs = (value, index, origin = null) => {
        let searchObj = {
            'data_type': 'SONGS',
            'search_string': value,
        }
        let flags = [...this.state.isSongFetching]
        if(origin==="fromDidMount"){
            flags[index] = false;
        }else{
            flags[index] = true;
        }
        this.setState({ displayAddNewSongOption: false, isSongFetching: flags, searchedSongString: value, searchedSongIndex: index });
        if (this.state.searchCancelToken != null){
            this.state.searchCancelToken.cancel("Operation canceled due to new request");
        }
        var cancelToken = axios.CancelToken.source();
        this.setState({searchCancelToken: cancelToken },()=>{
        ClearTrackService.getDataParamsWithCancel(Constants.ClearTrackServiceBaseUrl + '/globalSearch', searchObj, this.props.userContext?.active_tenant?.tenant_id, null, cancelToken)
            .then(response => {
                let exsitingSongs = this.state.mainTitleClearanceData?.songs_list?.map(item => item?.song_id)
                let formattedList = response?.data?.data?.map(item => ({ value: item?.id?.split('_')[1], text: item?.name, isSongActive : item?.is_active }))
                flags[index] = false
                this.setState({
                    isSongFetching: flags,
                    songOptions: formattedList?.filter(item => !exsitingSongs?.includes(item?.value) && item.isSongActive === 1),
                    displayAddNewSongOption:true
                }, () => {
                    flags[index] = false
                    this.setState({ selectSong: this.state?.newSongId?.toString()?.toLowerCase(), isSongFetching: flags });
                    if (origin === "fromNewSong") {
                        this.handleShowChange("song",
                            this.state.songOptions.find(songid => {
                                return songid.value == this.state.newSongId
                            })
                            , index)
                    }

                })
            },
                (err) => {
                    this.setState({ displayAddNewSongOption:false })
                }
            )
        });
        // if (value) {
        
    // }
    }
    getWriterList = (value,childIndex,parentIndex) => {
        let mainTitleClearanceData = JSON.parse(JSON.stringify(this.state.mainTitleClearanceData));
        
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel("Operation canceled due to new request");
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        // if (value) {
        // mainTitleClearanceData.songs_list[parentIndex].writer[childIndex].writer_name = value;
        // mainTitleClearanceData.songs_list[parentIndex].writer[childIndex].writer_id = value;
        this.setState({ isFetchingWriter: true})
        ClearTrackService.getDataWithCancel(Constants.ClearTrackServiceBaseUrl + `/entitySearch?entity=WRITER&searchString=${value}`, cancelToken, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response?.data?.filter(writer => writer?.is_active === 1)?.map(item => ({ 
                    value: item.writer_id, 
                    text: item.writer_name, 
                    affiliation_name: item.affiliation_name, 
                    share: item?.share, 
                    affiliation_id: item?.affiliation_id, 
                    temp_writer_name: `${item.writer_name}${(item.affiliation_name && item.affiliation_name != null) ? '-' + item.affiliation_name : ''} ${(item.affiliation_name && item.share_percentage != 0 && item.share_percentage != null) ? item.share_percentage : ''}` }));
                this.setState({ writerOptions: formattedList, isFetchingWriter: false })
            },
                (err) => {
                    console.log("Error in fetching entities:", err)
                })
        // }

    }

    getMainTitleRecord = (main_title_id) => {
        this.setState({ isFetchingMainTitleDetails: true });
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/mainTitle?main_title_id=${main_title_id}`, this.props.userContext?.active_tenant?.tenant_id, this.props.division_id)
            .then(response => {
                let mainTitleList = response?.data[0]
                if(mainTitleList?.songs_list?.length > 0){
                    mainTitleList?.songs_list?.map((song,index)=>{
                        if(song?.writer?.length == 0){
                            song?.writer.push(JSON.parse(JSON.stringify({ ...mainTitleWritersList })));
                        }else{
                            song?.writer?.map((item) => {
                            item['temp_writer_name'] = `${item?.writer_name ? item?.writer_name : ''}${(item?.affiliation_name && item?.affiliation_name != null) ? '-' + item?.affiliation_name : ''} ${(item?.affiliation_name && item?.share_percentage != 0 && item?.share_percentage != null) ? item?.share_percentage : ''}`;
                            item.writer_name = `${item?.writer_name ? item?.writer_name : ''}${(item?.affiliation_name && item?.affiliation_name != null) ? ' (' + item?.affiliation_name + ')' : ''} ${(item?.affiliation_name && item?.share_percentage != 0 && item?.share_percentage != null) ? item?.share_percentage : ''}`;
                            item.song_writer_is_delete = item?.song_writer_is_delete ? 1 : 0,
                            item.selected_writer = {
                                value: item?.writer_id,
                                text: item?.writer_name
                            }}
                        ) 
                        }
                    })
                }
                let sondDonotArr = mainTitleList?.songs_list?.map(item => item?.is_do_not_use)
                let existingSongs = mainTitleList?.songs_list
                this.setState({
                    mainTitleClearanceData: mainTitleList ? this.formatMainTitleClearanceDetails(JSON.parse(JSON.stringify(mainTitleList))) : this.formatMainTitleClearanceDetails(JSON.parse(JSON.stringify({ ...initialMaintitleClearanceRecord }))),
                    isFetchingMainTitleDetails: false,
                    division_id: response?.data[0]?.division_id,
                    songUse: sondDonotArr,
                    existingSongList: existingSongs
                })
                // if (mainTitleList?.show_id) {
                //     this.getSeasons(mainTitleList?.show_id)
                // }
            },
                (err) => {
                    console.log("Error in fetching entities:", err)
                    this.setState({ isFetchingMainTitleDetails: false });
                })
    }



    getStaticData = (tableName, fieldName) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/staticData?staticTable=${tableName}`, null)
            .then(response => {
                let formattedList = response.data?.map(item => ({ value: item.id, label: item.name }));
                this.setState({ [fieldName]: formattedList, });
            },
                (err) => {
                    console.log("Error in fetching Details:", err)
                })
    }
    postSendDataEmail = (payload) => {
        const tenantId = this.props?.userContext?.active_tenant?.tenant_id;
        this.setState({ isSendEmail: true });
        ClearTrackService.postDataParams(`${Constants.ClearTrackServiceBaseUrl}/sendEmail`, payload, tenantId)
            .then(() => this.setState({ isSendEmail: false }))
            .catch(() => this.setState({ isSendEmail: false }));
    };

    isTrackableWriter = (writer, writerIdKey) => {
        return !!(writer?.writer_id || writer?.[writerIdKey]);
    };

    getActiveWriters = (writers = [], writerIdKey) => {
        return (writers || []).filter(
            writer => writer?.song_writer_is_delete !== 1 && this.isTrackableWriter(writer, writerIdKey)
        );
    };

    findMatchingWriter = (writer, writers = [], writerIdKey) => {
        if (writer?.[writerIdKey]) {
            return writers.find(item => item?.[writerIdKey] === writer?.[writerIdKey]);
        }
        if (writer?.writer_id) {
            return writers.find(item => item?.writer_id === writer?.writer_id && !item?.[writerIdKey]);
        }
        return null;
    };

    trackWriterChangesForSong = (originalWriters = [], currentWriters = []) => {
        const writerIdKey = 'main_title_song_writer_id';
        const changes = [];
        const activeOriginalWriters = this.getActiveWriters(originalWriters, writerIdKey);
        const activeCurrentWriters = this.getActiveWriters(currentWriters, writerIdKey);

            activeCurrentWriters.forEach(newWriter => {
            const existingWriter = this.findMatchingWriter(newWriter, activeOriginalWriters, writerIdKey);

            if (!existingWriter) {
                if (newWriter?.writer_id && newWriter?.writer_name) {
                    changes.push({
                        type: "added",
                        writer: newWriter.writer_name
                    });
                }
            } else {
                const hasChanges = (
                    existingWriter?.writer_name !== newWriter?.writer_name ||
                    existingWriter?.share_percentage !== newWriter?.share_percentage ||
                    existingWriter?.affiliation_name !== newWriter?.affiliation_name
                );

                if (hasChanges) {
                    changes.push({
                        type: "changed",
                        original: existingWriter?.writer_name,
                        updated: newWriter?.writer_name
                    });
                }
            }
        });

       activeOriginalWriters.forEach(existingWriter => {
            const newWriter = this.findMatchingWriter(existingWriter, activeCurrentWriters, writerIdKey);
            if (!newWriter && existingWriter?.writer_name) {
                changes.push({
                    type: "removed",
                    writer: existingWriter.writer_name
                });
            }
        });

        (currentWriters || []).forEach(writer => {
            if (writer?.song_writer_is_delete !== 1 || !this.isTrackableWriter(writer, writerIdKey)) return;
            if (!writer?.writer_name) return;

            const wasTracked = changes.some(
                change => change.type === "removed" && change.writer === writer.writer_name
            );
            if (!wasTracked) {
                changes.push({
                    type: "removed",
                    writer: writer.writer_name
                });
            }
        });

        return changes;
    };

    sendEditSongEmailNotifications = (postJson) => {
        if (!this.state.isMusicSupervisorEmail) return;

        (postJson?.songs_list || []).forEach((song) => {
            if (song?.is_delete === 1 || !song?.song_id) return;

            const originalSong = (this.state.existingSongList || []).find(
                item => item?.main_title_song_id === song?.main_title_song_id
            ) || (this.state.existingSongList || []).find(
                item => item?.song_id === song?.song_id
            );

            if (!originalSong) return;

            const writerChanges = this.trackWriterChangesForSong(originalSong?.writer, song?.writer);

            if (writerChanges.length > 0) {
                const payload = {
                    letter_type: "editSongDetailNotification",
                    song_title: song?.song_title,
                    licensor_changes: [],
                    performer_licensor_changes: [],
                    writer_changes: writerChanges,
                    performer_changes: [],
                    cue_sheet_publisher_changes: [],
                    pd_composer_changes: []
                };
                this.postSendDataEmail(payload);
            }
        });
    };

    handleSubmit = () => {
        this.setState({ postInitiated: true })
        let data = null;
        data = JSON.parse(JSON.stringify(this.state.mainTitleClearanceData));
        data.show_id = this.props?.showId || null
        data.season_id = this.props?.seasonId || null
        data.show_season_id = this.props?.show_season_id || null
        if (this.validateFlagError(data)) {
            this.postMainTitle(data);
        }
    }

    validateFlagError = (data) => {
        let canSubmit = false;
        canSubmit = (
            data?.show_id && data?.season_id && data?.show_season_id && data?.show_yr &&
            (data?.guaranteed_eps ? data?.guaranteed_eps <= this.props.episodeLength : true) && (data?.songs_list?.length > 0 && this.validateSongs(data?.songs_list)) && validateNumbersOnly(data?.show_yr))
        return canSubmit;
    }
    validateSongs(songList) {
        let canSubmit = true;
        let i = 0;
        for (i; i < songList?.length; i++) {
            let obj = songList[i];
            if ((!obj.song_id || !obj.song_title || !obj.performer_id || !obj.performer_name || !obj.music_uses_id) ||  ( this.state.useOptions?.find(item => item?.value === obj.music_uses_id)?.label !== 'Custom Use' ? 
            (obj?.sec ? !(obj?.sec < 60 && validateNumbersOnly(obj?.sec)) : false) || (obj?.min ? !(validateNumbersOnly(obj?.min)) : false) : false) ) {
                canSubmit = false;
                break;
            }
        }
        return canSubmit;
    }

    postMainTitle = (postJson) => {
        this.setState({ isPosting: true, postInitiated: true })
        postJson.show_season_id = this.props.show_season_id
        postJson.clearance_rep_id = this.props?.clearance_rep_id || null
        if (this.state.deletedSongs.length > 0) {
            postJson.songs_list = [...postJson.songs_list, ...this.state.deletedSongs]
        }
        for(let i = 0 ; i < postJson.songs_list?.length ; i++) {
            postJson.songs_list[i].duration = `${postJson?.songs_list[i]?.min ? postJson.songs_list[i].min : 0}:${postJson.songs_list[i]?.sec ? postJson.songs_list[i]?.sec : 0}`
            delete postJson.songs_list[i].min
            delete postJson.songs_list[i].sec
            if(postJson.songs_list[i]?.is_CR_PD === null || postJson.songs_list[i]?.is_CR_PD === undefined){
                if(postJson.songs_list[i]?.is_PD===0 || postJson.songs_list[i]?.is_PD === null || postJson.songs_list[i]?.is_PD=== undefined){
                    postJson.songs_list[i].is_CR_PD = 0;
                }else{
                    postJson.songs_list[i].is_CR_PD = 1;
                }
            }
            delete postJson.songs_list[i].is_PD
            if (this.state.deletedWriters.length > 0) {
                this.state.deletedWriters.map((deletedWriter) => {
                    if(deletedWriter.main_title_song_id === postJson.songs_list[i].main_title_song_id){
                    delete deletedWriter.main_title_song_id;
                    postJson?.songs_list[i]?.writer?.push(deletedWriter);
                }})
            }
            if(postJson.songs_list[i]?.writer?.length > 0){
                const filteredWriters = postJson.songs_list[i]?.writer?.filter(
                    w => w.writer_id !== null || w.main_title_song_writer_id !== null
                );
                postJson.songs_list[i].writer= filteredWriters;
            }
        }
        let extensionUrl = '/mainTitle'
        ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + extensionUrl, postJson, this.props.userContext?.active_tenant?.tenant_id, this.props?.division_id)
            .then((response) => {
                if (!response.data.error) {
                    this.setState({ isPosting: false, postInitiated: false })
                    this.props?.fieldChanged(false, "error");
                    this.props?.notificationComponent(true, "success")
                    this.sendEditSongEmailNotifications(postJson);
                    setTimeout(() => {
                        if (this.props?.mode === "New") {
                            this.props?.toggleRefreshMainTitle(response?.data[0]?.main_title_id);
                            this.props.fetchData("getInitialValues", `/showSeason?showSeasonId=${this.props.show_season_id}`, false, "mainTitle");
                        } else {
                            this.props?.toggleRefreshMainTitleLicensor();
                        }
                    },1500)
                }
                else {
                    this.setState({ isPosting: false, postInitiated: false })
                    this.props?.notificationComponent(true, "fail")
                }
            },
                (err) => {
                    this.setState({ isPosting: false, postInitiated: false })
                    this.props?.notificationComponent(true, "fail")
                    console.log("Post agency details error: " + err);
                });
    }

    handleChange = (field, value, index=null) => {
        if(field === "writer"){
            this.setState((prevState) => ({
                mainTitleClearanceData: {
                    ...prevState.mainTitleClearanceData,
                    [field]: value,
                },
                postInitiated: false
            }));

        }else if(field==="is_all_promo_use_restricted" || field === "is_limited_promo_use" || field==="is_library" || field === "is_coa" || field==="is_contains_sample" || field === "is_studio_owned" || field === "is_arrangement" || field === "is_CR_PD" || field === "is_do_not_use"){ 
            let selectedSong =  this.state.mainTitleClearanceData?.songs_list[index]
            selectedSong[field] = value ? 1 : 0;
            if(field==="is_all_promo_use_restricted"){
                selectedSong["is_limited_promo_use"] = 0;
            }
            let tempMainTitleClearanceData = JSON.parse(JSON.stringify(this.state.mainTitleClearanceData?.songs_list))
            tempMainTitleClearanceData[index]=selectedSong;
            this.setState(prevState => ({
                mainTitleClearanceData: {
                    ...prevState.mainTitleClearanceData,
                    "songs_list": tempMainTitleClearanceData,
                    "is_songs_updated": 1
                }
            }));
        }else if (field === "is_apply_to_HV") {
            this.setState({
                mainTitleClearanceData: {
                    ...this.state.mainTitleClearanceData,
                    [field]: value ? 1 : 0,
                },
            });
        }
        else {
            this.setState((prevState) => ({
                mainTitleClearanceData: {
                    ...prevState.mainTitleClearanceData,
                    [field]: value,
                },
            }));
        }
        this.props?.fieldChanged(true, "change")
    }

    removeField(field,index,parentIndex=null){
        let data = { ...this.state.mainTitleClearanceData }        
        let deleteExistingItem = null;
        switch  (field){
            case "song":
            let deletedItem = data?.songs_list[index]
            if (deletedItem?.main_title_song_id) {
                deletedItem.is_delete = 1
                let deletedSongs = [...this.state.deletedSongs, deletedItem]
                this.setState({ deletedSongs: deletedSongs })
                data.is_songs_updated = 1
            }
            data.songs_list.splice(index, 1)
            deleteExistingItem = this.state.existingSongList.filter(item => item.song_id !== deletedItem?.song_id)
            this.setState({ mainTitleClearanceData: data, postInitiated: false, existingSongList: deleteExistingItem })
            this.props?.fieldChanged(true, "change")
            break;
            case "writer":
                let writerToDelete = data?.songs_list?.[parentIndex]?.writer?.[index];
                if (writerToDelete?.main_title_song_writer_id) {
                    writerToDelete.song_writer_is_delete = 1;
                    writerToDelete.main_title_song_id = data?.songs_list?.[parentIndex]?.main_title_song_id;
                    let deletedWriters = [...this.state.deletedWriters, writerToDelete]
                    this.setState({ deletedWriters: deletedWriters })
                }
            data.is_songs_updated = 1
                data.songs_list[parentIndex].writer.splice(index, 1);
                if(data.songs_list[parentIndex].writer.length === 0){
                    data.songs_list[parentIndex].writer.push(JSON.parse(JSON.stringify({ ...mainTitleWritersList })));
                }
            this.setState({ mainTitleClearanceData: data, postInitiated: false })
            this.props?.fieldChanged(true, "change")
            break;
        }
    }
    handleCloseEditSongModal = () => {
                this.setState({ isEditingPerformer: false });
    };

    addField(fieldName, index=null, parentIndex=null) {
        switch (fieldName) {
            case "song":
                let data = { ...this.state.mainTitleClearanceData }; 
                data.songs_list.push(JSON.parse(JSON.stringify({ ...mockSong2 })))
                this.setState({ mainTitleClearanceData: data, postInitiated: false, songOptions:[] })
                this.props?.fieldChanged(true, "change")
                break;
            case "writer":
                let mainTitleClearanceData = { ...this.state.mainTitleClearanceData }
                if (mainTitleClearanceData?.songs_list?.[parentIndex]?.writer?.[index]?.writer_name) {
                    let writersArray = JSON.parse(JSON.stringify({ ...mainTitleWritersList }));
                    let writer = JSON.parse(JSON.stringify(mainTitleClearanceData?.songs_list?.[parentIndex]?.writer));
                    writer.push(writersArray);
                    // console.log("writer in mainTitleClearanceData.songs_list[parentIndex]",mainTitleClearanceData.songs_list[parentIndex])
                    mainTitleClearanceData.songs_list[parentIndex].writer = writer;
                    this.setState({ mainTitleClearanceData, postInitiated: false, writerOptions: []});
                    this.props?.fieldChanged(true, "change")
                }
                break;
            default:
                break;
        } 
    } 

    onConfirmInActiveSong = ()=>{
        this.setState({ 
            openInActiveSongModal : false, 
            newSongPopup: true 
         })
    }
    onCloseInActiveSong =()=>{
        this.setState({openInActiveSongModal : false, proposedNewSong : null})
    }
    handleShowChange = (fieldName, value, index, origin=null,parentIndex=null) => {
        let data = null;
        data = { ...this.state.mainTitleClearanceData }
        if (fieldName === "song") {
            this.setState({ searchSelect: true })
            if (value?.optionType == 'new') {
                this.getInactiveSongs(value.value, index)
                .then(result => { 
                    if(!this.state.openInActiveSongModal){
                        this.setState({ newSongPopup: true, proposedNewSong: value, newSongRowIndex: index })
                    }
                    if(result.length > 0){
                        const inActiveSong = result.map(item => item.songWithWriter)
                            .filter(Boolean) // Remove any falsy values (e.g., undefined)
                            .join(', ');
                        this.setState({inActiveSong :inActiveSong, proposedNewSong: value, newSongRowIndex: index })
                    }
                })
                .catch(error => {
                    console.error("Error:", error);
                });
                // this.postPerformer(value?.value, index)
            } else {
                if (value) {
                    data.songs_list[index][fieldName + '_id'] = value?.value || null;
                    data.songs_list[index][fieldName + '_title'] = value?.text || null;
                    data.songs_list[index]['selected_song'] = value || null;
                    data.songs_list[index]["performer_id"] = null;
                    data.songs_list[index]["performer_name"] = null;
                    data.songs_list[index]["selected_performer"] = null;
                    data.is_songs_updated = 1
                    data.songs_list[index]["songLoader"] = true;
                    this.getPerformer(value?.value, index);
                } else {
                    data.songs_list[index][fieldName + '_id'] = null;
                    data.songs_list[index][fieldName + '_title'] = null;
                    data.songs_list[index]['selected_song'] = null;
                    data.songs_list[index]["performer_id"] = null;
                    data.songs_list[index]["performer_name"] = null;
                    data.songs_list[index]["selected_performer"] = null;
                    data.songs_list[index]["songLoader"] = false;
                    this.setState({ performerOptions: [] })
                }
                this.setState({ proposedNewSong: null, newSongRowIndex: null });
            }
            this.setState({loadingSongs:false})
        }
        else
            if (fieldName === "min" || fieldName === "sec") {
                data.songs_list[index][fieldName] = value
                data.is_songs_updated = 1
            }
            else if (fieldName === "music_uses_id") {
                data.songs_list[index][fieldName] = value
                data.is_songs_updated = 1
                data.songs_list[index]['custom_use'] = this.state.useOptions?.find(item => item?.value === value)?.label !== 'Custom Use' ? null : data.songs_list[index]['custom_use'] || null
            }
            else if (fieldName === "performer") {
                data.songs_list[index][fieldName + '_id'] = value?.value || null;
                data.songs_list[index][fieldName + '_name'] = value?.text || null;
                data.songs_list[index]['selected_performer'] = value;
                data.songs_list[index]['songLoader'] = false
                data.is_songs_updated = 1
               const selectedPerformerId = value?.value;
               const songId = data.songs_list[index]?.song_id;
            if (songId && selectedPerformerId) {
                this.getPerformer(songId, index, selectedPerformerId);
         }                               
            } else if (fieldName === 'custom_use') {
                data.songs_list[index][fieldName] = value
                data.songs_list[index]['customPopover'] = null
                data.is_songs_updated = 1
            }
            else if (fieldName === 'writer') {
                let songs_list = JSON.parse(JSON.stringify(this.state.mainTitleClearanceData.songs_list));
                songs_list[parentIndex].writer[index]['writer_id'] = value?.value || null;
                songs_list[parentIndex].writer[index]['writer_name'] = value?.text || null;
                songs_list[parentIndex].writer[index]['selected_writer'] = value;
                songs_list[parentIndex].writer[index]['affiliation_id'] = value?.affiliation_id || null;
                songs_list[parentIndex].writer[index]['affiliation_name'] = value?.affiliation_name || null;
                songs_list[parentIndex].writer[index]['temp_writer_name'] = `${value?.text ? value?.text : ''}${(value?.affiliation_name && value?.affiliation_name != null) ? '-' + value?.affiliation_name : ''} ${(value?.affiliation_name && value?.share_percentage != 0 && value?.share_percentage != null) ? value?.share_percentage : ''}`;
                songs_list[parentIndex].writer[index]['share_percentage'] = 0;
                if(!songs_list[parentIndex].writer[index]['clearance_song_writer_id']){
                    songs_list[parentIndex].writer[index]['clearance_song_writer_id'] = null;
                }
                songs_list[parentIndex].writer[index]['is_active'] = 1;
                data.songs_list= songs_list
                data.is_songs_updated = 1
            }
            else {
                data.songs_list[index][fieldName] = value
            }
        this.setState({ mainTitleClearanceData: data,loadingSongs:false, writerMode: null, }, () => {
            if (fieldName === 'customPopover') {
                this.setState({ customNotes: value ? data.songs_list[index]['custom_use'] : null })
            }
            if (fieldName === 'custom_use') {
                this.setState({ customNotes: null })
            }
        })
        this.props?.fieldChanged(true, "change")
    }
    newSongPopup() {
        this.setState({ newSongPopup: false, proposedNewSong : null});
    }
    newSongId(songId, songTitle = null, index = 0) {
        this.setState({ newSongId: songId, searchSelect: false,loadingSongs:true }, () => {
            this.setState({ newSongPopup: false });
            this.getSongs(songTitle, index, "fromNewSong");
        });
    }
    onDropdownClose = () => {
        this.setState({songOptions: [], searchedSongIndex: null, searchedSongString: null})
    }
    render() {
        let editMainTitlePermissions = this.props?.isMainTitle ? this.props?.mainTitlePermissions?.find((per) => clearanceRecordPermissionsConfig.find((item) => item.buttonName == "New CR" && item.permissionGroupName.includes(per.permission_group_name))) : null;
        let data = null;
        let heading = null;
        data = {...this.state.mainTitleClearanceData}
        heading = "For " + data.show_name + "_" + data.season_name
        let isLoading = data;
        let newMode = "For " + this.props?.show_name + "-" + this.props?.season_name
        return (
            <>
                {this.state.isFetchingMainTitleDetails  ? (
                    <div style={{ textAlign: "center" }}>
                        <CircularProgress size={24} />
                    </div>
                ) : (
                        <MDBContainer fluid className="ModalContainer ClearanceRecordContainer NewClearanceRecordContainer">
                            {
                            this.state.inActiveSongFeatching ? 
                            <div style={{ textAlign: "center" }}>
                                <CircularProgress size={24} />
                            </div> :
                                this.state.openInActiveSongModal &&(
                                    <MessageModal
                                    open={this.state.openInActiveSongModal}
                                    title={"Message"}
                                    message={`There is an Inactive song ${this.state?.inActiveSong}. Still do you want to create new song?`}
                                    hideCancel={false}
                                    primaryButtonText={"OK"}
                                    secondaryButtonText={"Cancel"}
                                    onConfirm={() => this.onConfirmInActiveSong()}
                                    handleClose={(e) => this.onCloseInActiveSong()}
                                    />
                                )
                            }
                            <div className="between">
                                <div>
                                    {
                                        this.props?.from ? null :
                                            <BasicLabel
                                                text={this.props.mode === "Edit" ? heading : newMode}
                                            />
                                    }
                                </div>
                                <div>
                                    <BasicLabel text={"Clearance Rep"} />
                                    <div className="clearanceRepText">{this.props?.clearance_rep || "-"}</div>
                                </div>
                            </div>
                            {(this.state.loadingSongs) ?
                                    <CircularProgress color="inherit" size={15} />
                                    :
                            this.state.mainTitleClearanceData?.songs_list?.map((song, index) => (
                                <MDBRow key={"dropdownrow" + index}>
                                    
                                    <MDBCol className="songsDropdown" md={4} disabled={this.state.existingSongList[index]?.song_id === song.song_id ? true : false}>
                                        <BasicLabel text={'Song(s)'} />
                                        <SearchFieldWithAddValue
                                            id={`song${index}`}
                                            placeholder={'- Search -'}
                                            width={'100%'}
                                            //searchSelect={true}
                                            isMandatory={true}
                                            //multiple={false}
                                            showMandatory={this.state.postInitiated}
                                            mandatoryWarning={messages.mandatoryWarning}
                                            loading={this.state.isSongFetching[index]}
                                            detail_selected={song?.song_title && song?.song_title?.trim() !== "" ? song?.song_title : this.state?.proposedNewSong?.value}
                                            options={this.state.songOptions || []}
                                            searchSelect={this.state.searchSelect}
                                            onChange={(e, newValue) => this.handleShowChange("song", newValue, index)}
                                            searchText={ev => {
                                                // dont fire API if the user delete or not entered anything
                                                if (ev.target.value !== "" && ev.target.value !== null) {
                                                    this.getSongs(ev.target.value, index)
                                                }
                                            }}
                                            newLabel={'Song'}
                                            displayAddNewSongOption={this.state.displayAddNewSongOption}
                                            onDropdownClose = {this.onDropdownClose.bind(this)}
                                        />
                                        {
                                            this.state.songUse[index] === 1
                                                ?
                                                <span>
                                                    <span class="donot"><i>DO NOT USE song</i> </span>
                                                </span>
                                                : ""
                                        }
                                    </MDBCol>
                                    {/* disabled={(!song.song_id || this.state.existingSongList[index]?.song_id === song.song_id) ? true : false} */}
                                    <MDBCol md={3} id="performer" >
                                        {song?.songLoader ? <CircularProgress size={15} /> : <SearchSelectField
                                            id={`performer${index}`}
                                            label={"Perfomer"}
                                            placeholder={'- Search -'}
                                            isMandatory={true}
                                            showMandatory={this.state.postInitiated}
                                            mandatoryWarning={messages.mandatoryWarning}
                                            options={this.state.performerOptions[index] || []}
                                            searchSelect={true}
                                            detail_selected={song?.selected_performer}
                                            loading={this.state.isPerformerFetching[index]}
                                            width={'100%'}
                                            valueSelected={(e, newValue) => this.handleShowChange("performer", newValue, index)}
                                            searchText={ev => {
                                                if (ev.target.value !== "" && ev.target.value !== null) {
                                                    this.getPerformerDetails(ev.target.value, index)
                                                } else {
                                                    let flags = [...this.state.isPerformerFetching]
                                                    flags[index] = false
                                                    this.setState({ isPerformerFetching: flags })
                                                }
                                            }}
                                        />}
                                    </MDBCol>

                                    {this.state.useOptions?.find(item => item?.value === song.music_uses_id)?.label !== 'Custom Use' ? <MDBCol md={2} className='flex justify-content-between'>
                                        <BasicTextField
                                            label={"Min"}
                                            placeholder={"__"}
                                            value={song.min}
                                            fieldValid={song.min ? !validateNumbersOnly(song.min) : false}
                                            inValidInput={"Invalid Min."}
                                            onChange={(e) => this.handleShowChange("min", e.target.value.length > 0 ? e.target.value : null, index)} />
                                        <BasicTextField
                                            value={':'}
                                            label={" "}
                                            showAsLabel={true} />
                                        <BasicTextField
                                            label={"Sec"}
                                            placeholder={"__"}
                                            value={song.sec}
                                            fieldValid={song.sec ? !(validateNumbersOnly(song.sec) && song.sec < 60) : false}
                                            inValidInput={"Invalid Sec."}
                                            onChange={(e) => this.handleShowChange("sec", e.target.value.length > 0 ? e.target.value : null, index)} />
                                    </MDBCol> :
                                        <MDBCol>
                                            <BasicLabel text={'Duration'} />
                                            <BasicButton
                                                onClick={(e) => {
                                                    this.handleShowChange("customPopover", e.currentTarget, index)
                                                }}
                                                variant="outlined"
                                                text={"View"}
                                            />
                                            <Popover
                                                id={index + song?.music_uses_id}
                                                open={Boolean(song?.customPopover)}
                                                anchorEl={song?.customPopover}
                                                getContentAnchorEl={null}
                                                onClose={() => {
                                                    this.handleShowChange("customPopover", null, index)
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                PaperProps={{
                                                    style: {
                                                        width: '30%',
                                                        borderRadius: '1px',
                                                    }
                                                }}
                                            >
                                                <BasicTextArea
                                                    label={""}
                                                    rows={5}
                                                    value={this.state.customNotes || null}
                                                    onChange={(e) =>
                                                        this.setState({ customNotes: e.target.value?.length > 0 ? e.target.value : null })
                                                    }
                                                />
                                                <MDBRow className="mt-2">
                                                    <MDBCol md={8}>
                                                        <BasicButton
                                                            text={"Sync Use Only"}
                                                            onClick={() => {
                                                                let currentString = this.state.customNotes
                                                                currentString = currentString ? currentString?.includes('SYNC:') ? currentString : 'SYNC: ' + currentString : 'SYNC: '
                                                                this.setState({ customNotes: currentString })
                                                            }}
                                                        />
                                                    </MDBCol>
                                                    <MDBCol md={4}>
                                                        <BasicButton
                                                            text={"OK"}
                                                            onClick={() => {
                                                                this.handleShowChange("custom_use", this.state.customNotes, index)
                                                            }}
                                                        />
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow className="mt-2">
                                                    <MDBCol md={8}>
                                                        <BasicButton
                                                            text={"Master Use Only"}
                                                            onClick={() => {
                                                                let currentString = this.state.customNotes
                                                                currentString = currentString ? currentString?.includes('MASTER:') ? currentString : currentString + '\nMASTER: ' : '\nMASTER: '
                                                                this.setState({ customNotes: currentString })
                                                            }}
                                                        />
                                                    </MDBCol>
                                                    <MDBCol md={4}>
                                                        <BasicButton onClick={() => this.handleShowChange("customPopover", null, index)} variant="outlined" text={"Cancel"} />
                                                    </MDBCol>
                                                </MDBRow>
                                            </Popover>
                                        </MDBCol>}
                                    <MDBCol md={2} id="music_use">
                                        <SelectField
                                            label={"Use"}
                                            isMandatory={true}
                                            showMandatory={this.state.postInitiated}
                                            mandatoryWarning={messages.mandatoryWarning}
                                            placeHolderText={"- Select - "}
                                            value={song.music_uses_id}
                                            options={this.state.useOptions?.filter(item => item?.is_active === 1 || item?.value == song.music_uses_id) || []}
                                            onChange={(e) => this.handleShowChange("music_uses_id", e.target.value, index)}
                                        />
                                    </MDBCol>
                                    <MDBCol md={1} className={index === 0 ? "align-end" : "self-center"}>
                                        <div className="add-remove-icons">
                                            <div>
                                                {!(data.songs_list.length === 1)
                                                    ? <RemoveCircleIcon fontSize="small" onClick={() => this.removeField("song",index)} />
                                                    : null
                                                }
                                            </div>
                                            <div className="ml5">
                                                {
                                                    data.songs_list.length - 1 === index && song.song_id != null ?
                                                        <AddCircleIcon fontSize="small" onClick={() => this.addField("song", index)} />
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md={4}> 
                                        {
                                            song?.writer?.map((writer, index2) => (
                                                (writer?.song_writer_is_delete === 0 ? <>
                                                    <MDBCol md={8} className={"col-content d-inline-block"} id="writer">
                                                        <SearchSelectField
                                                            id={"writer-select"}
                                                            label={index2 === 0 ? "Writers" : ""}
                                                            options={this.state.writerOptions}
                                                            multiple={false}
                                                            detail_selected={writer?.selected_writer ? writer?.selected_writer : null}
                                                            valueSelected={(e,newValue)=> {
                                                                this.handleShowChange('writer', newValue || null, index2,null,index)
                                                                this.setState({ writerOptions: [] });
                                                            }}
                                                            searchText={(e, value) => {
                                                                if (e.target.value !== "" && e.target.value !== null) {
                                                                    this.getWriterList(e.target.value, index2, index)
                                                                } 
                                                            }}
                                                            searchSelect={true}
                                                        />
                                                    </MDBCol>
                                                    <MDBCol md={4} className="actionButons2 d-inline-block">
                                                        <MDBRow>
                                                            { //this.state?.editWriterNamePermission && !writer?.writer_id &&
                                                                <MDBCol md={1} className='pensquareicon'>
                                                                    <MDBIcon
                                                                        icon={'pen-square'}
                                                                        disabled={!writer?.writer_id ? true : false}
                                                                        onClick={(e) => {
                                                                            writer?.writer_id?
                                                                            this.setState({
                                                                                writerMode: writer?.writer_id ? {
                                                                                    value: writer?.writer_id,
                                                                                    text: writer?.temp_writer_name,

                                                                                } : 'new', selectedWriterIndex: index, selectedSongIndex: index2
                                                                            }):null
                                                                        }}
                                                                    />
                                                                </MDBCol>
                                                            }
                                                            <MDBCol className={"removeActionIcon"} md={1}>
                                                                {
                                                                    (writer.writer_name?.length > 0) ?
                                                                        <RemoveCircleIcon onClick={(e) => this.removeField("writer", index2, index)} />
                                                                        : null
                                                                }
                                                            </MDBCol>
                                                            <MDBCol className={this.state.songDetails?.writer?.length === 1 ? 'notDisabled addIconMargin' : 'notDisabled'} md={1}>
                                                                {
                                                                    (writer.writer_name?.length > 0 && index2 === (song?.writer?.length - 1)) ?
                                                                        <AddCircleIcon onClick={(e) => this.addField("writer", index2, index)}/> 
                                                                        : 
                                                                        null
                                                                }
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </> : null)
                                            ))
                                        }
                                    </MDBCol>
                                    <MDBCol md = {7} className="songCheckboxContainer">
                                        <BasicCheckbox
                                            id={"is_library"+index}
                                            label="Library"
                                            align="end"
                                            checked={song?.is_library}
                                            onChange={(e) => this.handleChange("is_library", e.target.checked,index)}
                                        />
                                        <BasicCheckbox
                                            id={"song_is_do_not_use"+index}
                                            label="Do not Use"
                                            align="end"
                                            checked={song?.is_do_not_use}
                                            onChange={(e) => this.handleChange("is_do_not_use", e.target.checked,index)}
                                        />
                                        <BasicCheckbox
                                            id={"is_studio_owned"+index}
                                            label="Studio Owned"
                                            align="end"
                                            checked={song?.is_studio_owned}
                                            onChange={(e) => this.handleChange("is_studio_owned", e.target.checked,index)}
                                        />
                                        <BasicCheckbox
                                            id={"is_contains_sample"+index}
                                            label="Contains Sample(s)"
                                            align="end"
                                            checked={song?.is_contains_sample}
                                            onChange={(e) => this.handleChange("is_contains_sample", e.target.checked,index)}
                                        />
                                        {/* <BasicCheckbox
                                            id={"is_pd"+index}
                                            label="Public Domain"
                                            align="end"
                                            checked={song?.is_CR_PD}
                                            //disabled={this.props?.mode === "Edit" ? true : false}
                                            onChange={(e) => this.handleChange("is_CR_PD", e.target.checked,index)}
                                        /> */}
                                        <BasicCheckbox
                                            id={"is_all_promo_use_restricted"+index}
                                            label="No Promo Use Allowed"
                                            align="end"
                                            checked={song?.is_all_promo_use_restricted}
                                            onChange={(e) => {
                                                this.handleChange("is_all_promo_use_restricted", e.target.checked,index)
                                            }}
                                        />
                                        <BasicCheckbox
                                            id={"is_arrangement"+index}
                                            label="Is Arrangement"
                                            align="end"
                                            checked={song?.is_arrangement}
                                            onChange={(e) => this.handleChange("is_arrangement", e.target.checked,index)}
                                        />
                                        <BasicCheckbox
                                            id={"is_coa"+index}
                                            label="COA"
                                            align="end"
                                            checked={song?.is_coa}
                                            onChange={(e) => this.handleChange("is_coa", e.target.checked,index)}
                                        />
                                    </MDBCol>
                                </MDBRow>
                            ))}
                            <MDBRow className="mt-2">
                                <MDBCol md={8}>
                                    <MDBRow>
                                        <MDBCol md={8}>
                                            <BasicTextArea
                                                label={"Main Title Credits"}
                                                value={data.main_title_credits}
                                                onChange={(e) => this.handleChange("main_title_credits", e.target.value)}
                                            />
                                        </MDBCol>
                                        <MDBCol md={4} className={"display-eps"}>
                                            <MDBRow>
                                                <MDBCol md={8}>
                                                    <BasicTextField label={"Guaranteed Eps"}
                                                        value={data.guaranteed_eps || null}
                                                        onChange={(e) => this.handleChange("guaranteed_eps", e.target.value.length > 0 ? e.target.value : null)}
                                                        fieldValid={!(data.guaranteed_eps <= this.props.episodeLength) && data.guaranteed_eps}
                                                        inValidInput={"Guaranteed Eps should be less than equal to total Eps"}
                                                    />
                                                </MDBCol>
                                                <MDBCol md={4}>
                                                    <div className={"episode-text"}>
                                                        <p>({this.props.episodeLength} Total)</p>
                                                    </div>
                                                </MDBCol>
                                            </MDBRow>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                                <MDBCol md={4}>
                                    <MDBRow>

                                        <MDBCol md={6}>
                                            <BasicTextField label={"Show Yr"}
                                                isMandatory={true}
                                                showMandatory={this.state.postInitiated}
                                                mandatoryWarning={messages.mandatoryWarning}
                                                value={data.show_yr}
                                                onChange={(e) => this.handleChange("show_yr", e.target.value)}
                                                fieldValid={data.show_yr ? !validateNumbersOnly(data.show_yr) : false}
                                                inValidInput={"Please enter number"}
                                            />
                                        </MDBCol>
                                        {<MDBCol className={"mt-2"} md={6}>
                                            <BasicCheckbox
                                                id="Hv"
                                                label={"Apply $ to HV"}
                                                checked={data.is_apply_to_HV}
                                                onChange={(e) => this.handleChange("is_apply_to_HV", e.target.checked)}
                                            />
                                        </MDBCol>}
                                    </MDBRow>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <MDBRow>
                                <MDBCol md={10}></MDBCol>
                                <MDBCol md={2}>
                                    <MDBRow>
                                        <MDBCol>
                                            <BasicButton text={this.state.isPosting ? <CircularProgress color="inherit" size={20} /> : this.props?.mode === "Edit" ? "Save" : "Create"} onClick={this.handleSubmit} disabled={this.props?.isMainTitle ? (editMainTitlePermissions?.edit == 1 ? false : true) : false}/>
                                        </MDBCol>
                                        <MDBCol>
                                            <BasicButton onClick={() => this.props?.handleClose()} variant="outlined" text={"Cancel"} />
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    )
                }
                 {
                    this.state.isEditingPerformer &&
                        <MainViewModalComponent
                            open={this.state.isEditingPerformer}
                            handleClose={this.handleCloseEditSongModal.bind(this)}
                            headerText={"Song"}
                            mode={"Edit"}
                            modalName={"Song"}
                            songId={this.state.mainTitleClearanceData.songs_list[this.state.editingPerformerSongIndex]?.song_id}
                            commonPermissions={this.props?.userContext?.active_tenant?.common_permissions}
                            toggleRefreshPage={this.props?.toggleRefreshPage}
                            division_id={this.props?.division_id}
                            toggleRefreshMainTitleLicensor={this.props?.toggleRefreshMainTitleLicensor}
                            handleFilterSearch = {this.props.handleFilterSearch}
                            origin={"fromPerformerEdit"}                  
                            selectedPerformer={{ performer: this.state.mainTitleClearanceData.songs_list[this.state.editingPerformerSongIndex]?.selected_performer }}
                            selectedPerformerIndex = {this.state.editingPerformerSongIndex}
                            handleSongDataChange={this.handleShowChange.bind(this)}
                        />
                                                           
              }
                
                <Popover
                    open={this.state.newSongPopup}
                    getContentAnchorEl={null}
                    onClose={() => this.newSongPopup()}
                    anchorOrigin={{
                        vertical: '5%',
                        horizontal: 'center',
                    }}
                    anchorPosition={{ top: 100 }}
                    transformOrigin={{
                        vertical: '5%',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        style: {
                            width: '70%',
                            borderRadius: '1px',
                            padding:'0px'
                        }
                    }}
                >
                    <EditSongDetails
                        songId={this.props?.songId}
                        mode={"new"}
                        fieldChanged={this.props?.fieldChanged}
                        setPostFlag={this.props?.setPostFlag}
                        handleClose={this.newSongPopup.bind(this)}
                        notificationComponent={this.props?.notificationComponent}
                        toggleRefreshPage={this.props?.toggleRefreshPage}
                        //toggleRefreshMainTitleLicensor={this.props?.toggleRefreshMainTitleLicensor}
                        PopoverTitle={"New Song"}
                        songModalPermissions={this.props?.episodeSongPermissions ? this.props?.episodeSongPermissions : this.props?.commonPermissions?.find(item => item.permission_group_name == "Songs")}
                        proposedNewSong={this.state?.proposedNewSong?.value}
                        newSongId={this.newSongId.bind(this)}
                        newSongRowIndex={this.state.newSongRowIndex}
                        origin="clearanceRecord"
                    />
                </Popover>
                {this.state.writerMode && <MainViewModalComponent
                    open={this.state.writerMode ? true : false}
                    handleClose={() =>
                        this.setState({
                            writerMode: null,
                            selectedWriterIndex: null,
                        })
                    }
                    headerText={"Writer"}
                    mode={this.state.writerMode !== 'new' ? "Edit" : 'Add'}
                    writerId={this.state.writerMode || null}
                    modalName={"On Fly Lookup"}
                    type={'writer'}
                    division_id={this.state?.division_id}
                    handleAddWriter={(writerData) => {
                        let index = this.state.selectedWriterIndex
                        let index2 = this.state.selectedSongIndex
                        this.handleShowChange('writer', writerData || null, index2,null,index)
                    }}
                    origin="clearanceRecord"
                    songDetails={this.state.mainTitleClearanceData?.songs_list?.[this.state.selectedSongIndex]?.writer?.[this.state.selectedWriterIndex] || null}
                    songId={this.props?.songId}
                    selectedWriterIndex = {this.state.selectedWriterIndex}
                    selectedSongIndex = {this.state.selectedSongIndex}
                />}
            </>
        );
    }
}
export default withUserContext(NewMainTitleClearanceRecord);
